import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';

export const useExperimentalCreateAutomationRuleFromTemplateMutation = ({
	onCompleted,
	onError,
}) => {
	return useExperimentalMutation<
		ExperimentalCreateAutomationRuleFromTemplateMutation,
		ExperimentalCreateAutomationRuleFromTemplateMutationVariables,
		ExperimentalCreateAutomationRuleFromTemplateResponse
	>({
		url: ({ cloudId, automationStack }) =>
			`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/public/rest/v1/template/create`,
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: ({ templateId, cloudId, spaceId, parameters }) => {
			const ruleHome = spaceId
				? `ari:cloud:confluence:${cloudId}:space/${spaceId}`
				: `ari:cloud:confluence::site/${cloudId}`;

			let formattedParameters: {
				[name: string]: {
					value: string;
					type: string;
				};
			} | null = null;
			if (parameters) {
				formattedParameters = {};
				for (const parameter of parameters) {
					formattedParameters[parameter.name] = {
						value: parameter.value,
						type: parameter.type,
					};
				}
			}

			return JSON.stringify({
				templateId,
				ruleHome,
				parameters: formattedParameters,
			});
		},
		parseResult: ({ ruleId, ruleUuid }) => ({
			experimentalCreateAutomationRuleFromTemplate: {
				ruleId,
				ruleUuid,
			},
		}),
		onCompleted,
		onError,
	});
};

enum TemplateParameterTypeEnum {
	BOOLEAN = 'BOOLEAN',
	NUMBER = 'NUMBER',
	TEXT = 'TEXT',
}

interface ExperimentalCreateAutomationRuleFromTemplateParameter {
	name: string;
	type: TemplateParameterTypeEnum;
	value: string;
}
interface ExperimentalCreateAutomationRuleFromTemplate {
	ruleId: string | null;
	ruleUuid: string | null;
}

interface ExperimentalCreateAutomationRuleFromTemplateMutation {
	experimentalCreateAutomationRuleFromTemplate: ExperimentalCreateAutomationRuleFromTemplate | null;
}

interface ExperimentalCreateAutomationRuleFromTemplateMutationVariables {
	templateId: string;
	cloudId: string;
	automationStack: string;
	spaceId?: string | null;
	parameters?: ExperimentalCreateAutomationRuleFromTemplateParameter[] | null;
}

interface ExperimentalCreateAutomationRuleFromTemplateResponse {
	ruleId: string;
	ruleUuid: string;
}
